/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { getPopularDestinations } from '../../../_integrations/everymundo/destinations';
import { isSSR } from '@front10/utils';
import { withCommonPreloads } from './commons/commonPreloads';
import { popularDestinationsToFlatFares } from '../../../_integrations/everymundo/utils/normalizeFareLikeData';

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: { integrationSettings, prePopulation, meta, pageContext }
      },
      name,
      simulateSSR
    } = cmpConfig;

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(
        getPopularDestinations(prePopulation, integrationSettings, meta, pageContext)
      );
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([other, popularDestinations]) => {
        cmpConfig.containerConfig.settings.getPopularDestinations = getPopularDestinations;
        cmpConfig.containerConfig.settings.initialPopularDestinations = popularDestinations;
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = popularDestinationsToFlatFares(
          popularDestinations
        );
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(preloadCustomPropsExecute, cmpConfig);
};

export default preloadCustomProps;
